module.exports = __webpack_public_path__ + "media/index/briefcase-43cb979f.svg";